// @system — Auth page content (template defaults).
// Overwritten during template sync. Products override in @custom/auth.js.
export default {
  loginTitle: 'Welcome back',
  loginSubtitle: 'Sign in to your account',
  registerTitle: 'Create your account',
  registerSubtitle: 'Start your free trial today',
}
